export type BookingStatus = 'Confirmed' | 'Pending' | 'Cancelled' | 'Completed' | 'On Hold';
export type PayStatus = 'Paid' | 'Partial' | 'Unpaid' | 'Refunded';
export type ServiceType = 'Package' | 'Flight' | 'Hotel' | 'Tour' | 'Visa' | 'Transfer' | 'Cruise';
export type PayMethod = 'Bank Transfer' | 'Credit Card' | 'Cash' | 'Cheque';

export interface SupplierInfo {
  name: string;
  type: string;
  contactPerson: string;
  phone: string;
  email: string;
  reference: string;
  costPrice: number;
  sellPrice: number;
}

export interface Payment {
  id: string;
  date: string;
  amount: number;
  method: PayMethod;
  reference: string;
  notes: string;
  recordedBy: string;
}

export interface Booking {
  id: string;
  customer: string;
  customerAvatar: string;
  customerPhone: string;
  customerEmail: string;
  service: string;
  serviceType: ServiceType;
  serviceIcon: string;
  destination: string;
  travelDate: string;
  returnDate: string;
  nights: number;
  pax: number;
  status: BookingStatus;
  totalAmount: number;
  paidAmount: number;
  currency: string;
  payStatus: PayStatus;
  supplier: SupplierInfo;
  payments: Payment[];
  agent: string;
  agentAvatar: string;
  createdAt: string;
  notes: string;
}

export const bookingsData: Booking[] = [];

export const serviceTypeIcons: Record<string, string> = {
  Package: 'ri-suitcase-line',
  Flight: 'ri-flight-takeoff-line',
  Hotel: 'ri-hotel-line',
  Tour: 'ri-map-2-line',
  Visa: 'ri-passport-line',
  Transfer: 'ri-car-line',
  Cruise: 'ri-ship-line',
};
